import React from 'react'
import { CardActions, Grid, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import Button from '../../../../../../UI/Button/Button'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

const AssignActionControls = ({
  form,
  formInputChanged,
  submitted,
  cancelled,
  submitButtonDisabled,
  stageList,
  translate
}) => {
  let selected = null
  const stageOptions = stageList.map(item => {
    if (+form?.default_stage_id === +item.stage_id || +form?.stage_id === +item.stage_id) {
      selected = { key: +item.stage_id, value: +item.stage_id, label: item.status_name }
    }
    return { key: +item.stage_id, value: +item.stage_id, label: item.status_name }
  })
  return (
    <CardActions style={{ padding: 0, paddingTop: 8 }}>
      <Grid container justify={'space-around'}>
        <Grid container item xs md={8} lg={9}>
          <Grid item xs md={5} lg={3}>
            <Autocomplete
              value={selected}
              size={'small'}
              onChange={(e, value) =>
                formInputChanged({ ...form, stage_id: +value?.value || null })
              }
              options={stageOptions}
              getOptionLabel={option => option.label || ''}
              renderInput={params => (
                <TextField
                  style={{ width: '100%' }}
                  {...params}
                  label={translate('action')}
                  variant={'outlined'}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid container item xs md={4} lg={3} justify={'space-evenly'} alignItems={'flex-end'}>
          <Grid item xs style={{ marginRight: '1rem' }}>
            <Button color={'primary'} clicked={submitted} disabled={submitButtonDisabled} fullWidth>
              {translate('save')}
            </Button>
          </Grid>
          <Grid item xs>
            <Button color={'default'} clicked={cancelled} fullWidth>
              {translate('cancel')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </CardActions>
  )
}

export default withTranslate(AssignActionControls)
